import { render } from "./ProjectInfoView.vue?vue&type=template&id=3d61d9bb&scoped=true"
import script from "./ProjectInfoView.vue?vue&type=script&lang=js"
export * from "./ProjectInfoView.vue?vue&type=script&lang=js"

import "./ProjectInfoView.vue?vue&type=style&index=0&id=3d61d9bb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3d61d9bb"

export default script